// extracted by mini-css-extract-plugin
export var card = "_84-1";
export var container = "_84-0";